function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 640,
  height: 160,
  y: 160,
  fill: "#fff",
  fillRule: "evenodd",
  rx: 0,
  ry: 0
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 640,
  height: 160,
  y: 320,
  fillRule: "evenodd",
  rx: 0,
  ry: 0
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "red",
  fillRule: "evenodd",
  d: "M0 0h640v160H0z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#090",
  fillRule: "evenodd",
  d: "M201.9 281l-28.8-20.9-28.7 21.1 10.7-34.2-28.7-21.2 35.4-.3 11-34.1 11.3 34h35.4L191 246.9l10.9 34.2zm307.6 0l-28.8-20.9-28.7 21.1 10.7-34.2-28.6-21.2 35.4-.3 11-34.1 11.2 34h35.4l-28.5 21.4 11 34.2z"
});

var SvgSy = function SvgSy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 480"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default SvgSy;